<ng-template cdkPortalOutlet></ng-template>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/@angular/material/dialog/typings/index.d.ts.MatDialogContainer.html